<template>
  <div class="mine-center-page">
    <!-- 用户信息头部 -->
    <div class="user-header">
      <van-icon name="contact" size="40" color="#fff" class="avatar" />
      <div class="user-info">
        <div class="user-name">{{ userName }}</div>
        <div class="user-phone">{{ userPhone }}</div>
      </div>
    </div>

    <!-- 功能菜单 -->
    <div class="menu-card">
      <van-cell-group :border="false">
        <van-cell title="实名认证" icon="user-o" is-link @click="goPage('/mine/userInfo')" />
        <van-cell title="结算记录" icon="records" is-link @click="goPage('/mine/settlement')" />
        <!-- <van-cell title="申报明细" icon="notes-o" is-link @click="goPage('/mine/declare')" /> -->
        <van-cell title="关于我们" icon="info-o" is-link @click="goPage('/mine/about')" />
      </van-cell-group>
    </div>

    <footer-menu></footer-menu>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import footerMenu from '@/components/footer/FooterMenu'

export default {
  name: 'MineCenter',
  components: {
    footerMenu
  },
  computed: {
    ...mapState(['userInfo']),
    // 姓名（无姓名时显示占位）
    userName () {
      console.log('打印用户信息', this.userInfo)
      return (this.userInfo && this.userInfo.name) || '用户'
    },
    // 手机号（无手机号时显示商户编号）
    userPhone () {
      return (this.userInfo && this.userInfo.mobile) || localStorage.getItem('MERNO') || ''
    }
  },
  created () {
    // 获取用户信息（vuex 缓存，避免重复请求）
    this.$store.dispatch('fetchUserInfo').catch(err => {
      console.log('获取用户信息失败', err)
    })
  },
  methods: {
    goPage (path) {
      this.$router.push({ path })
    }
  }
}
</script>
<style scoped lang="less">
/*
 * 注意：项目 postcss 按 750 设计稿宽度将 px 自动转成 vw（src 代码），
 * 即源码数值是设计稿坐标，实际渲染大小 = 数值 ÷ 2。
 */
.mine-center-page {
  min-height: 100%;
  background: #f5f5f5;
}

/* 用户信息头部 */
.user-header {
  display: flex;
  align-items: center;
  padding: 40px 32px;
  background: linear-gradient(135deg, #ff6034, #e92504);

  .avatar {
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    background: rgba(255, 255, 255, 0.25);
    border-radius: 50%;
  }

  .user-info {
    margin-left: 24px;
    text-align: left;

    .user-name {
      font-size: 38px;
      font-weight: 600;
      color: #fff;
    }

    .user-phone {
      margin-top: 8px;
      font-size: 26px;
      color: rgba(255, 255, 255, 0.8);
      word-break: break-all;
    }
  }
}

/* 功能菜单 */
.menu-card {
  margin: 20px;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;

  /deep/ .van-cell {
    font-size: 30px;
    color: #323233;

    .van-cell__title {
      text-align: left;
    }
  }
}
</style>
